module.exports = __webpack_public_path__ + "assets/1240d11cc19cd795760c90213f62e3a3.png";